import { atom } from "jotai";

export const floatComponentsOpen = atom<Set<string>>(new Set<string>());
